import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
export function EmployeeActivityRowHeader(_ref) {
  let {
    claim,
    sortedClaimProjectReports,
    setHeaderScrollPosition,
    isShowInvolvement
  } = _ref;
  const reportsHeaderRef = useRef(null);
  const {
    t
  } = useTranslation();
  const onHeaderScroll = e => {
    setHeaderScrollPosition(e.target.scrollLeft);
  };
  const headerStyle = minMaxWidth => {
    return {
      minWidth: minMaxWidth,
      maxWidth: minMaxWidth
    };
  };
  const showInvolvementHeader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "Involvement"), /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, t('qualifying'), /*#__PURE__*/React.createElement("br", null), " ", t('expenditure')));
  };
  const showRndHeader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "Direct R&D%"), /*#__PURE__*/React.createElement("div", {
      className: "border-end cost_categories_subpage_header_cell"
    }, "Months"), /*#__PURE__*/React.createElement("div", {
      className: "border-start cost_categories_subpage_header_cell"
    }, "Indirect R&D%"), /*#__PURE__*/React.createElement("div", {
      className: "border-end cost_categories_subpage_header_cell"
    }, "Months"));
  };
  const ReportSubheader = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, sortedClaimProjectReports.map((report, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "bg-primary text-white border-start border-end cost_categories_subpage_header_cell_container"
      }, report.project_name || 'Unnamed Project');
    })), /*#__PURE__*/React.createElement("div", {
      className: "d-flex"
    }, sortedClaimProjectReports.map((_, index) => {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex cost_categories_subpage_header_cell_container",
        key: index
      }, isShowInvolvement ? showInvolvementHeader() : showRndHeader());
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: "break-text"
  }, /*#__PURE__*/React.createElement("th", {
    style: headerStyle('120pt')
  }, "Name"), /*#__PURE__*/React.createElement("th", {
    style: headerStyle('120pt')
  }, "Role"), isShowInvolvement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", {
    style: headerStyle('120pt')
  }, "Direct R&D %"), /*#__PURE__*/React.createElement("th", {
    style: headerStyle('120pt')
  }, "Indirect R&D %"), /*#__PURE__*/React.createElement("th", {
    style: headerStyle('70pt')
  }, "R&D %")), claim.claim_group.project_methodology === 'project_basis' ? /*#__PURE__*/React.createElement("th", null, /*#__PURE__*/React.createElement("div", {
    "data-testid": "scroll-container",
    ref: reportsHeaderRef,
    onScroll: onHeaderScroll,
    className: "cost_categories_subpage_header"
  }, /*#__PURE__*/React.createElement(ReportSubheader, null))) : null, !isShowInvolvement && /*#__PURE__*/React.createElement("th", {
    style: headerStyle('70pt')
  }, "R&D %"), /*#__PURE__*/React.createElement("th", {
    style: headerStyle('120pt')
  }, "Total Costs"), /*#__PURE__*/React.createElement("th", {
    style: headerStyle('120pt')
  }, "R&D Amount"), /*#__PURE__*/React.createElement("th", {
    style: headerStyle('120pt')
  }, "Group Individuals as 'Various' within R&D Report")));
}